// @flow
import type {
  Emit,
} from '../core/events';
import type {
  IsFqdnAvailable,
} from '../core/fqdn';
import type {
  Initialize,
  SendAnalytics,
} from '../core/ga';
import type {
  GetSuggestions,
} from '../core/suggestions';
import type {
  GetSessionId,
} from '../domain/browserSession';

import {
  epic as modalEpic,
} from '@team-griffin/redux-modal-router';
import * as epics from './epics';

type Deps = {
  emit: Emit,
  isFqdnAvailable: IsFqdnAvailable,
  initialize: Initialize,
  sendAnalytics: SendAnalytics,
  getSuggestions: GetSuggestions,
  getSessionId: GetSessionId,
  analyticsContext: { trackerId: string },
};

export default ({
  emit,
  isFqdnAvailable,
  initialize,
  sendAnalytics,
  getSuggestions,
  getSessionId,
  analyticsContext,
  analyticsQueue,
}: Deps) => {
  return epics.rootEpic(
    epics.analyticsWorkerEpic(window, analyticsQueue),
    epics.backorderDomainEpic(sendAnalytics),
    epics.filterEpic(sendAnalytics),
    epics.filterSearchEpic(),
    epics.filterTldEpic(),
    epics.gaInitEpic(analyticsContext, initialize),
    epics.localeEpic(),
    epics.purchaseDomainEpic(isFqdnAvailable, sendAnalytics),
    epics.purchaseBundleEpic(sendAnalytics),
    epics.resetFiltersEpic(sendAnalytics),
    epics.searchEpic(getSuggestions, sendAnalytics, document),
    epics.seedEpic(),
    epics.sessionEpic(getSessionId),
    epics.transferDomainEpic(sendAnalytics),
    epics.viewBasketEpic(sendAnalytics),
    epics.negotiateEpic(),
    epics.emitEpic(emit),
    modalEpic,
  );
};
